import React, { Suspense } from 'react';

// eslint-disable-next-line react/display-name
const lazify =
  (dynamicComponent, fallback = <span />) =>
  (props) => (
    <Suspense fallback={fallback}>
      {React.createElement(React.lazy(dynamicComponent), props)}
    </Suspense>
  );

export default lazify;
